/* unplugin-vue-components disabled */import i18n from '@/lang';
/* this file is transformed by vux-loader */
/* eslint-disable */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import Toast from "vux/src/components/toast/index.vue"; // this line is trasformed by vux-loader
import Loading from "vux/src/components/loading/index.vue"; // this line is trasformed by vux-loader
import MapFactory from '@/utils/map/MapFactory.js';
var map = {};
export default {
  components: {
    Cell: Cell,
    Toast: Toast,
    Loading: Loading
  },
  props: {
    title: {
      type: String,
      default: i18n.tc("100")
    },
    address: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      currValue: this.value,
      currAddress: this.address,
      longitude: '',
      latitude: '',
      loadingShow: false,
      hasTitleSlot: false
    };
  },
  computed: {
    currAddressForShow: function currAddressForShow() {
      if (this.currAddress && this.currAddress.length > 0 && this.currAddress[0] !== '') {
        return this.currAddress[0];
      }
      return '';
    }
  },
  watch: {
    value: function value(val) {
      this.currValue = val;
    },
    address: function address(val) {
      this.currAddress = val;
    },
    currValue: function currValue(val) {
      this.$emit('on-change', val, this.currAddress);
      this.$emit('input', val);
    }
  },
  mounted: function mounted() {
    this.$slots.title && (this.hasTitleSlot = true);
    map = MapFactory.create('map-box');
    map.init();
  },
  methods: {
    position: function position() {
      var _this = this;
      this.loadingShow = true;
      var geolocation = map.createGeolocation({
        enableHighAccuracy: true,
        // 是否使用高精度定位，默认:true
        timeout: 10000 // 超过10秒后停止定位，默认：5s
      });
      geolocation.getCurrentPositionFix(function (status, result) {
        _this.loadingShow = false;
        _this.currAddress = status;
        if (status === 'complete') {
          _this.longitude = result.position.lng;
          _this.latitude = result.position.lat;
          _this.currAddress = result.formattedAddress || '';
          _this.currValue = [_this.longitude, _this.latitude];
        } else {
          _this.$vux.toast.text(i18n.tc("482"));
        }
      });
    }
  }
};